export const FORMAT = 'format';

export const SERIES = 'series';
